import * as React from 'react';
import LoadingWithMessage from '../../../misc/components/LoadingWithMessage';
import { DeviceItem } from '../Confirmation';
import { ConfigureVitaloJak1 } from './ConfigureVitaloJak1';
import { StudyScheduleSession, Subject } from 'webportalclient';
import { useWebPortalApiClient, useWebPortalLegacyClient } from '../../../misc/api/WebPortalTokenClient';
import { useAuth } from "react-oidc-context";

interface VitaloJak1ConfigureStateProps {
    subject: Subject;
    session: StudyScheduleSession;
    deviceId: string;
    device: DeviceItem;
    isNotConfigured: boolean;
}

interface VitaloJak1ConfigureDispatchProps {
    onError: (message: string) => void;
    onComplete: () => void;
}

type VitaloJak1ConfigureProps = VitaloJak1ConfigureStateProps & VitaloJak1ConfigureDispatchProps;

export const VitaloJak1Configure = ({ subject, session, deviceId, device, isNotConfigured, onError, onComplete }: VitaloJak1ConfigureProps) => {
    const legacyClient = useWebPortalLegacyClient();
    const client = useWebPortalApiClient();
    const { user } = useAuth();

    const configure = async () => {
        await ConfigureVitaloJak1(
            client.client,
            legacyClient,
            user?.profile.email,
            subject,
            session,
            deviceId,
            device,
            isNotConfigured,
            onError,
            onComplete
        );
    }

    React.useEffect(() => {
        configure();
    }, []);

    return (
        <div className="modal-body">
            <LoadingWithMessage message="Configuring device..." />
        </div>
    );
}
